import React, {Fragment} from "react";
import {RoleDto} from "@reside/reside-api-app";

import {AdmissionStatus} from "../../services/AdmissionsService";
import {AdminRoles} from "../admin-roles";
import {AdmissionCellRenderer} from "./AdmissionCellRenderer";
import {ArchiveAdmissionReminder} from "./atoms/archive-admission-reminder";
import {AdmissionCellErrorBoundary} from "./AdmissionCellErrorBoundary";

export const AdmissionCellList = ({admissions}: {admissions: any}) => (
  <>
    {admissions.map((admission: any, idx: any) => (
      <Fragment key={admission.id}>
        {admission.status === AdmissionStatus.APPROVED && idx === 0 && (
          <AdminRoles
            roles={[
              RoleDto.NameEnum.CLERK,
              RoleDto.NameEnum.ADMISSIONS_DIRECTOR,
              RoleDto.NameEnum.FACILITY_ADMIN,
              RoleDto.NameEnum.ORGANIZATION_ADMIN,
              RoleDto.NameEnum.REGIONAL_ADMIN,
            ]}
          >
            <ArchiveAdmissionReminder />
          </AdminRoles>
        )}
        <AdmissionCellErrorBoundary>
          <AdmissionCellRenderer key={admission.id} admission={admission} />
        </AdmissionCellErrorBoundary>
      </Fragment>
    ))}
  </>
);
